import React, { useRef, useState } from "react";
import { Formik } from "formik";
import CMSFormInput from "../../formFields/CMSFormInput";
import CMSFormSelect from "../../formFields/CMSFormSelect";
import GeneralButton from "../../common/GeneralButton";
import ContainerLoading from "../../common/loading/ContainerLoading";
import { useToast } from "../../contexts/ToastContext";
import { childSchema } from "../../utils/validations";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import axios from "../../../config/axios"; // ✅ make sure this path is correct

const AddChildInfo = ({ child }) => {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const refs = {
    firstName: useRef(null),
    lastName: useRef(null),
    age: useRef(null),
    gender: useRef(null),
    school: useRef(null),
  };

  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (!firstErrorField || !refs[firstErrorField]?.current) return;

    const el = refs[firstErrorField].current;
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    setTimeout(() => el.focus?.({ preventScroll: true }), 500);
  };

  return (
    <div className="mt-6 flex flex-col gap-6 bg-[#DEE2DD]/40 rounded-[15px] p-6 pb-10 lg:px-12 w-full relative">
      {/* Header */}
      <div className="flex items-center gap-4 mb-0">
        {/* <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 pe-3 py-2 bg-gray-200 rounded hover:bg-gray-300 transition"
        >
          <FiArrowLeft size={30} />
        </button> */}
        <p className="text-24pt">Add Child Info</p>
      </div>

      <div className="flex flex-col gap-6 rounded-[15px] relative">
        {/* Loading overlay */}
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center rounded-[15px] z-10 bg-white/50">
            <ContainerLoading />
          </div>
        )}

        {/* Formik Form */}
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            age:  "",
            gender: "",
            schoolName:  "",
          }}
          validationSchema={childSchema}
          onSubmit={async (values, { resetForm }) => {
            setLoading(true);
            try {
              // ✅ Real API call
              const { data } = await axios.post(
                `/dashboard/kids`,
                values
              );

              addToast(
                `Child details updated successfully.`,
                "success"
              );

              // Optionally refresh or navigate
              navigate(-1);
            } catch (err) {
              console.error("Failed to add child info:", err);
              setError(
                err?.response?.data?.message ||
                  "Failed to add child details. Please try again."
              );
              setTimeout(() => {
                setError("");
              }, 5000);
            } finally {
              setLoading(false);
            }
          }}
        >
          {(form) => (
            <div className="w-full grid grid-cols-1 gap-8 px-3">
              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <CMSFormInput
                  name="firstName"
                  label="First Name"
                  form={form}
                  className="1"
                  ref={refs.firstName}
                  required
                />
                <CMSFormInput
                  name="lastName"
                  label="Last Name"
                  form={form}
                  className="1"
                  ref={refs.lastName}
                  required
                />
              </div>

              {/* Age & Gender */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <CMSFormInput
                  name="age"
                  label="Age"
                  form={form}
                  className="1"
                  ref={refs.age}
                />
                <CMSFormSelect
                  name="gender"
                  label="Gender"
                  onChange={form.handleChange}
                  selected={form.values.gender}
                  placeholder={{ label: "Select Gender", value: "" }}
                  form={form}
                  className="1"
                  ref={refs.gender}
                  required
                  options={[
                    { label: "Girl", value: "Girl" },
                    { label: "Boy", value: "Boy" },
                  ]}
                />
              </div>

              {/* School */}
              <CMSFormInput
                name="schoolName"
                label="School"
                form={form}
                className="1"
                ref={refs.school}
              />
              {error && (
                <div
                  className={`relative transition-all duration-300 ease-in-out ${
                    error
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 -translate-y-2"
                  }`}
                >
                  {error && <span className="errorMessage">{error}</span>}
                </div>
              )}
              {/* Submit Button */}
              <div className="flex items-end justify-end">
                <GeneralButton
                  text="Submit"
                  type="submit"
                  className="text-21pt px-4"
                  textColor="#fff"
                  onClick={() => {
                    form.handleSubmit();
                    setTimeout(() => scrollToFirstError(form?.errors), 100);
                  }}
                />
              </div>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddChildInfo;
